import React from "react";

import CC from "core/ReusableIcons/CC";

export const PRO_ANNUAL_DOWNLOAD = "pro-yearly"; // these are plan IDs the BE expects
export const PRO_MONTHLY_DOWNLOAD = "pro-monthly";
export const PRO_SINGLE_DOWNLOAD = "SINGLE";
export const PRO_PREPAID_DOWNLOAD = "PREPAID";
export const FREE_DOWNLOAD = "FREE";

export const QUERY_OPTIONS = "options";
export const QUERY_PURCHASED = "purchase";

export const BASIC_DOWNLOAD_SIZE = 700;
export const DOWNLOAD_SIZES = [100, 128, 512, 1200, 3600];
export const SIZE_LABELS = {
    100: "x-small",
    128: "small",
    512: "medium",
    1200: "large",
    3600: "x-large"
};
export const DEFAULT_DOWNLOAD_SIZE = DOWNLOAD_SIZES[3];

export const DOWNLOAD_TYPES = ["SVG", "PNG"];
export const DEFAULT_DOWNLOAD_TYPE = DOWNLOAD_TYPES[0];

export const DEFAULT_COLOR = "#000000";

export const BACKGROUND_SHAPES = ["SQUARE", "ROUNDED_SQUARE", "RING", "CIRCLE"]; // enum of shapes recognized by backend
export const DEFAULT_BACKGROUND_SHAPE = BACKGROUND_SHAPES[0];

export const getIconFilename = ({ icon, type, color }) => {
    const fileType = type.toLowerCase();
    if (!icon) {
        return `noun-icon.${fileType}`;
    }
    const nameSuffix = `-${icon.slugWithId}`;
    const colorSuffix =
        color && color !== DEFAULT_COLOR
            ? `-${color.replace(/[^0-9A-Z]/gi, "")}`
            : "";
    return `noun${nameSuffix}${colorSuffix}.${fileType}`;
};

export const getLicenseSchema = (
    downloadType,
    { icon, hasEditedIcon, selected, setSelected }
) => {
    return {
        id: `radio-${downloadType.toLowerCase().replace(/[^a-z]/g, "")}`,
        backendKey: downloadType,
        title: getTitle(downloadType),
        badge: getBadge(downloadType, hasEditedIcon),
        selected: downloadType === selected,
        price: getPrice(downloadType),
        subscriptionTerm: getSubscriptionTerm(downloadType),
        optionName: getInnerButtonName(downloadType),
        icon: downloadType === FREE_DOWNLOAD ? <CC /> : null,
        onClick: () => setSelected(downloadType),
        meta: {
            message: getMessage(downloadType)
        }
    };
};

export const getValidKey = key => {
    key = String(key).toLowerCase();
    switch (key) {
        case PRO_ANNUAL_DOWNLOAD.toLowerCase():
            return PRO_ANNUAL_DOWNLOAD;
        case PRO_MONTHLY_DOWNLOAD.toLowerCase():
            return PRO_MONTHLY_DOWNLOAD;
        case PRO_SINGLE_DOWNLOAD.toLowerCase():
            return PRO_SINGLE_DOWNLOAD;
        case FREE_DOWNLOAD.toLowerCase():
            return FREE_DOWNLOAD;
        default:
            return null;
    }
};

const getTitle = downloadType => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
        case PRO_MONTHLY_DOWNLOAD:
            return "NounPro Unlimited";
        case PRO_SINGLE_DOWNLOAD:
            return "Single Pro Download";
        case FREE_DOWNLOAD:
            return "Basic Download";
    }
};

const getBadge = (downloadType, hasEditedIcon) => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
        case PRO_MONTHLY_DOWNLOAD:
            return hasEditedIcon ? "Keep your edits" : "Best value";
        default:
            return null;
    }
};

const getPrice = downloadType => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
            return "$39.99";
        case PRO_MONTHLY_DOWNLOAD:
            return "$9.99";
        case PRO_SINGLE_DOWNLOAD:
            return "$2.99";
        case FREE_DOWNLOAD:
            return "$0";
    }
};

const getSubscriptionTerm = downloadType => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
            return "year";
        case PRO_MONTHLY_DOWNLOAD:
            return "month";
        default:
            return null;
    }
};

const getInnerButtonName = downloadType => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
            return "Yearly";
        case PRO_MONTHLY_DOWNLOAD:
            return "Monthly";
        default:
            return null;
    }
};

const getMessage = downloadType => {
    switch (downloadType) {
        case PRO_ANNUAL_DOWNLOAD:
        case PRO_MONTHLY_DOWNLOAD:
            return "Get millions of SVG/PNG icons, editing & apps. Royalty-free license supports creators. No attribution required.";
        case PRO_SINGLE_DOWNLOAD:
            return "Royalty-free license & editing. Purchase supports creator. No attribution required.";
        case FREE_DOWNLOAD:
            return "Black & white, no edits. Must attribute creator per Creative Commons license.";
    }
};

export const getArrayOfCollectionIcons = ({ icons }) => {
    let iconPaths = [];

    icons.items.map(icon => {
        iconPaths.push(icon.previewUrl);
    });

    return iconPaths;
};
